import { requestWithMethod } from "../helpers/request";

export function fetchBrokerMetricsCards() {
  return requestWithMethod("/broker/metrics/cards", { method: "GET" });
}
